import { motionCount } from '../../../Foundation/motion';

export function Card() {
    // Find all Cards and then call motion on those with specific data attr
    let cards = document.querySelectorAll('.card');
    cards.forEach(card => {
        let countElement = card.querySelector('[data-motion-count]');
        if (countElement) {
            // Support multiple counts within 1 card
            let counts = card.querySelectorAll('[data-motion-count]');
            counts.forEach(count => {
                motionCount(count);
            });
        }
    });
}